import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const completedLessonOptions = {
  baseUrl: `${BACK_END_URL}/complete-lesson`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class CompletedLessonClient extends CandyClient {
  constructor() {
    super(completedLessonOptions);
  }

  async isLessonCompleted(leccion_id) {
    const response = await this.get(`/${leccion_id}`, {
        customHeaders: {
            Authorization: `Bearer ${getToken()}`,
        },
    });
    // Return `true` if fecha_completado is not null, otherwise `false`
    return response.fecha_completado !== null;
}

  async completeLesson(leccion_id) {
    return this.post("/", { leccion_id }, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
    });
  }

  async uncompleteLesson(leccion_id) {
    return this.delete(`/${leccion_id}`, null, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
  }
}